{
  "enum": {
    "IxcAssetsV1AccrualPeriod": {
      "CALENDAR_MONTH": "Calendar Month",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcAssetsV1AssetCategory": {
      "COMMON_EQUITY": "Common Equity",
      "EXCHANGE_TRADED_FUND": "Exchange Traded Fund",
      "MONEY_MARKET_FUND": "Money Market Fund",
      "PREFERRED_EQUITY": "Preferred Equity",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcAssetsV1AssetExceptionStatus": {
      "ACTIVE": "Active",
      "ARCHIVED": "Archived",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcAssetsV1AssetExceptionSummaryName": {
      "AssetExceptionSummary": "Asset Exception Summary",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcAssetsV1AssetStatus": {
      "ACTIVE": "Active",
      "INACTIVE": "Inactive",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcAssetsV1DividendPayableDate": {
      "FIRST_BUSINESS_DAY_OF_NEXT_MONTH": "First Business Day of Next Month",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcAssetsV1EodPriceStatus": {
      "COMPLETED": "Completed",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcAssetsV1FundFamily": {
      "JPMAM": "JPMAM",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcAssetsV1MoneyMarketClassification": {
      "GOVERNMENT": "Government",
      "OTHER": "Other",
      "RETAIL": "Retail",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcAssetsV1MoneyMarketNavType": {
      "FLOATING": "Floating",
      "STABLE": "Stable",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcAssetsV1MoneyMarketStatsStatus": {
      "COMPLETED": "Completed",
      "UNSPECIFIED": "Unspecified"
    },
    "IxcAssetsV1SymbolSuffix": {
      "CALLED": "Called",
      "CLASS_A": "Class A",
      "CLASS_A_CALLED": "Class A Called",
      "CLASS_A_WHEN_ISSUED": "Class A When Issued",
      "CLASS_B": "Class B",
      "CLASS_CONVERTIBLE": "Class Convertible",
      "CONVERTIBLE": "Convertible",
      "CONVERTIBLE_CALLED": "Convertible Called",
      "EMERGING_COMPANY_MARKETPLACE": "Emerging Company Marketplace",
      "NONE": "None",
      "PARTIAL_PAID": "Partial Paid",
      "PREFERRED": "Preferred",
      "PREFERRED_A_CALLED": "Preferred A Called",
      "PREFERRED_A_CONVERTIBLE": "Preferred A Convertible",
      "PREFERRED_A_WHEN_DISTRIBUTED": "Preferred A When Distributed",
      "PREFERRED_A_WHEN_ISSUED": "Preferred A When Issued",
      "PREFERRED_CALLED": "Preferred Called",
      "PREFERRED_CLASS_A": "Preferred Class A",
      "PREFERRED_CLASS_B": "Preferred Class B",
      "PREFERRED_WHEN_DISTRIBUTED": "Preferred When Distributed",
      "PREFERRED_WHEN_ISSUED": "Preferred When Issued",
      "RIGHTS": "Rights",
      "RIGHTS_WHEN_ISSUED": "Rights When Issued",
      "TEST_SYMBOL": "Test Symbol",
      "UNITS": "Units",
      "UNSPECIFIED": "Unspecified",
      "WARRANTS": "Warrants",
      "WARRANTS_CLASS_A": "Warrants Class A",
      "WARRANTS_CLASS_B": "Warrants Class B",
      "WARRANT_WHEN_ISSUED": "Warrant When Issued",
      "WHEN_DISTRIBUTED": "When Distributed",
      "WHEN_ISSUED": "When Issued"
    }
  },
  "filterEnum": {
    "IxcAssetsV1AssetExceptionQueryServiceAssetExceptionListFilterableFields": {
      "assetExceptionId": "Asset Exception",
      "data": {
        "observedDate": "Observed Date",
        "spec": {
          "assets": {
            "assetId": "Asset"
          }
        }
      },
      "status": "Status"
    },
    "IxcAssetsV1AssetQueryServiceAssetListFilterableFields": {
      "assetId": "Asset",
      "data": {
        "category": "Category",
        "type": {
          "!type": "Type",
          "equity": {
            "controls": {
              "canBuy": "Equity: Can Buy",
              "canEnterFractions": "Equity: Can Enter Fractions",
              "canSell": "Equity: Can Sell"
            },
            "cusip": "Equity CUSIP"
          },
          "moneyMarket": {
            "classification": "Money Market: Classification",
            "controls": {
              "canBuy": "Money Market: Can Buy",
              "canEnterFractions": "Money Market: Can Enter Fractions",
              "canSell": "Money Market: Can Sell"
            },
            "cusip": "Money Market CUSIP",
            "navType": "Money Market: NAV Type"
          }
        }
      },
      "status": "Status"
    },
    "IxcAssetsV1EodPriceQueryServiceEodPriceListFilterableFields": {
      "assetId": "Asset",
      "date": "Date",
      "status": "Status"
    },
    "IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsListFilterableFields": {
      "assetId": "Asset",
      "date": "Date",
      "status": "Status"
    }
  },
  "oneOf": {
    "IxcAssetsV1AssetEventType": {
      "archived": "Archived",
      "created": "Created",
      "updated": "Updated"
    },
    "IxcAssetsV1AssetExceptionEventType": {
      "archived": "Archived",
      "created": "Created",
      "updated": "Updated"
    },
    "IxcAssetsV1AssetType": {
      "cash": "Cash",
      "equity": "Equity",
      "moneyMarket": "Money Market"
    },
    "IxcAssetsV1EodPriceEventType": {
      "upserted": "Upserted"
    },
    "IxcAssetsV1MoneyMarketStatsEventType": {
      "upserted": "Upserted"
    }
  },
  "searchEnum": {
    "IxcAssetsV1AssetQueryServiceAssetListSearchableFields": {
      "data": {
        "type": {
          "equity": {
            "name": "Equity Name",
            "symbol": {
              "base": "Equity Symbol Base"
            }
          },
          "moneyMarket": {
            "name": "Money Market Name",
            "symbol": {
              "base": "Money Market Symbol Base"
            }
          }
        }
      }
    }
  },
  "sortEnum": {
    "IxcAssetsV1AssetExceptionQueryServiceAssetExceptionListSortableFields": {
      "data": {
        "observedDate": "Observed Date"
      },
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcAssetsV1AssetQueryServiceAssetListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcAssetsV1EodPriceQueryServiceEodPriceListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    },
    "IxcAssetsV1MoneyMarketStatsQueryServiceMoneyMarketStatsListSortableFields": {
      "metadata": {
        "createdAt": "Created At",
        "updatedAt": "Updated At"
      }
    }
  }
}